module.exports = __webpack_public_path__ + "static/media/chill-on-beach.e686edf6.png";